





























import { Component, Prop, Vue } from "vue-property-decorator";
import VMessageControl from "./VMessageControl.vue";
import MessageOutput from "@/models/message-output";

@Component({
  components: {
    "v-message-control": VMessageControl
  }
})
export default class ProjectReportPage extends Vue {
  @Prop() file?: File;
  @Prop({ default: false }) visible!: boolean;

  message = new MessageOutput();

  get src() {
    if (!this.file) return "";
    return URL.createObjectURL(this.file);
  }

  get filename() {
    if (!this.file) return "";
    return this.file.name;
  }

  save() {
    this.sendMessage();
  }

  async sendMessage() {
    if (!this.message.body) {
      if (!this.file) return;
      this.message.body = this.file.name;
    }
    this.$emit("sendMessage", this.message);
  }

  submit() {
    this.save();
    (this.$refs.modal as any).hide();
  }

  show() {
    this.message = new MessageOutput();
  }

  hide() {
    this.$emit("hide");
  }
}
